/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDUturnUpLeftIcon24Solid = forwardRef('ArrowDUturnUpLeftIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M8.724.806a1.5 1.5 0 0 1 2.052 2.188L7.57 6h5.93a8.5 8.5 0 0 1 0 17h-6a1.5 1.5 0 0 1 0-3h6a5.5 5.5 0 1 0 0-11H7.517l3.26 3.056a1.5 1.5 0 1 1-2.053 2.188l-4.832-4.53a3 3 0 0 1 0-4.378L8.724.806Z" })));
});
